import { axiosInstance } from "../../utils/axios";
import {
  CoObject,
  CoObjectDocumentPartInclude,
  CoObjectDropdown,
  ElaborationAbortRequest,
  TgkAmount,
  TgkAmountElaborationRequest,
  TgkAmountElaborationResponse,
  TgkDimensionAttributeElaborationRequest,
  TgkDimensionAttributeElaborationResponse,
  TgkTable,
  TgkTableElaborationRequest,
  TgkTableElaborationResponse,
  TgkTextElaborationRequest,
  TgkTextElaborationResponse,
  VersionedDocumentObject,
} from "../models";
import { SourceListItem } from "../../components/interfaces/SourceListItemObj";
import { TrackedObjChange } from "../../components/document/ObjectsListUpdatesPanel";
import { ComponentInstanceElaborationRequest } from "../models/component-instance-elaboration-request";
import { TgkElaborationResponse } from "../models/tgk-elaboration-response";
import { ComponentInstanceSimpleEditRequest } from "../models/component-instance-simple-edit-request";
import { ComponentInstanceSimpleEditResponse } from "../models/component-instance-simple-edit-response";
import { SyncVersionedDocumentObjectRequest } from "../models/sync-versioned-document-object-request";
import { TgkDimensionAttribute } from "../models/tgk-dimension-attribute";
import { TgkText } from "../models/tgk-text";

const BASE_PATH: string = "/coobject";
const BASE_PATH_SYNC: string = "/versioneddocumentobject";
const BASE_PATH_CHANGES_TRACKER: string = "/tracking";

/*
 ******* COMPONENT INSTANCE **********
 */
export function startElaborationForComponentInstanceInsert(
  request: ComponentInstanceElaborationRequest
): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/componentinstance/add`, request).then((resp) => resp.data);
}

export function simpleEditComponentInstance(
  request: ComponentInstanceSimpleEditRequest
): Promise<ComponentInstanceSimpleEditResponse> {
  return axiosInstance.post(`${BASE_PATH}/componentinstance/simpleedit`, request).then((resp) => resp.data);
}

export function startElaborationForComponentInstanceUpdate(
  request: ComponentInstanceElaborationRequest
): Promise<TgkElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/componentinstance/update`, request).then((resp) => resp.data);
}

export function deleteComponentInstance(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/componentinstance/delete/${coObjectId}`).then((response) => response);
}

/*
 ******* TABLE **********
 */
export function startElaborationForTgkTableInsert(
  request: TgkTableElaborationRequest
): Promise<TgkTableElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/table/add`, request).then((resp) => resp.data);
}

export function startElaborationForTgkTableUpdate(
  request: TgkTableElaborationRequest
): Promise<TgkTableElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/table/edit`, request).then((resp) => resp.data);
}

export function tgkTableUpdateSimple(request: TgkTableElaborationRequest): Promise<TgkTableElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/table/simpleedit`, request).then((resp) => resp.data);
}

export function getTgkTableByLogicId(logicId: string): Promise<TgkTable> {
  return axiosInstance.get(`${BASE_PATH}/table/by-logic-id/${logicId}`).then((resp) => resp.data);
}

/*
 ******* AMOUNT **********
 */
export function startElaborationForTgkAmountInsert(
  request: TgkAmountElaborationRequest
): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/amount/add`, request).then((resp) => resp.data);
}

export function startElaborationForTgkAmountUpdate(
  request: TgkAmountElaborationRequest
): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/amount/edit`, request).then((resp) => resp.data);
}

export function tgkAmountUpdateSimple(request: TgkAmountElaborationRequest): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/amount/simpleedit`, request).then((resp) => resp.data);
}

export function getTgkAmountByLogicId(logicId: string): Promise<TgkAmount> {
  return axiosInstance.get(`${BASE_PATH}/amount-or-aih/by-logic-id/${logicId}`).then((resp) => resp.data);
}

/*
 ******* AMOUNT AIH **********
 */

export function startElaborationForTgkAmountAihInsert(
  request: TgkAmountElaborationRequest
): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/amountaih/add`, request).then((resp) => resp.data);
}

export function startElaborationForTgkAmountAihUpdate(
  request: TgkAmountElaborationRequest
): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/amountaih/edit`, request).then((resp) => resp.data);
}

export function tgkAmountAihUpdateSimple(request: TgkAmountElaborationRequest): Promise<TgkAmountElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/amountaih/simpleedit`, request).then((resp) => resp.data);
}

/*
 ******* DIMENSION ATTRIBUTE **********\
 */
export function startElaborationForTgkDimensionAttributeInsert(
  request: TgkDimensionAttributeElaborationRequest
): Promise<TgkDimensionAttributeElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/dimensionattribute/add`, request).then((resp) => resp.data);
}

export function startElaborationForTgkDimensionAttributeUpdate(
  request: TgkDimensionAttributeElaborationRequest
): Promise<TgkDimensionAttributeElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/dimensionattribute/edit`, request).then((resp) => resp.data);
}

export function tgkDimensionAttributeUpdateSimple(
  request: TgkDimensionAttributeElaborationRequest
): Promise<TgkDimensionAttributeElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/dimensionattribute/simpleedit`, request).then((resp) => resp.data);
}

export function getTgkDimensionAttributeByLogicId(logicId: string): Promise<TgkDimensionAttribute> {
  return axiosInstance.get(`${BASE_PATH}/dimensionattribute/by-logic-id/${logicId}`).then((resp) => resp.data);
}

/*
 ******* CHECKBOX **********
 */
export function checkboxInsert(request: CoObject): Promise<CoObject> {
  return axiosInstance.post(`${BASE_PATH}/checkbox/add`, request).then((resp) => resp.data);
}

export function checkboxEdit(request: CoObject): Promise<CoObject> {
  return axiosInstance.put(`${BASE_PATH}/checkbox/edit`, request).then((resp) => resp.data);
}

/*
 ******* DROPDOWN **********
 */
export function dropdownInsert(request: CoObjectDropdown): Promise<TgkTableElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/dropdown/add`, request).then((resp) => resp.data);
}

export function dropdownEdit(request: CoObjectDropdown): Promise<CoObjectDropdown> {
  return axiosInstance.put(`${BASE_PATH}/dropdown/edit`, request).then((resp) => resp.data);
}

/*
 ******* FREE_TEXT **********
 */
export function freeTextInsert(request: CoObject): Promise<CoObject> {
  return axiosInstance.post(`${BASE_PATH}/freetext/add`, request).then((resp) => resp.data);
}

export function freeTextEdit(request: CoObject): Promise<CoObject> {
  return axiosInstance.put(`${BASE_PATH}/freetext/edit`, request).then((resp) => resp.data);
}

/*
 ******* TGK_TEXT **********
 */
export function startElaborationForTgkTextInsert(
  request: TgkTextElaborationRequest
): Promise<TgkTextElaborationResponse> {
  return axiosInstance.post(`${BASE_PATH}/tgktext/add`, request).then((resp) => resp.data);
}

export function startElaborationForTgkTextUpdate(
  request: TgkTextElaborationRequest
): Promise<TgkTextElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/tgktext/edit`, request).then((resp) => resp.data);
}

export function tgkTextUpdateSimple(request: TgkTextElaborationRequest): Promise<TgkTextElaborationResponse> {
  return axiosInstance.put(`${BASE_PATH}/tgktext/simpleedit`, request).then((resp) => resp.data);
}

export function getTgkTextByLogicId(logicId: string): Promise<TgkText> {
  return axiosInstance.get(`${BASE_PATH}/tgktext/by-logic-id/${logicId}`).then((resp) => resp.data);
}

/*
 ******* DOCUMENT_PART **********
 */
export function documentPartInsert(request: CoObject): Promise<CoObjectDocumentPartInclude> {
  return axiosInstance.post(`${BASE_PATH}/documentpartinclude/add`, request).then((resp) => resp.data);
}

export function documentPartLink(request: CoObject): Promise<CoObjectDocumentPartInclude> {
  return axiosInstance.post(`${BASE_PATH}/documentpartinclude/link`, request).then((resp) => resp.data);
}

export function documentPartNonTagetik(driveItemId: string, request: CoObject): Promise<CoObjectDocumentPartInclude> {
  return axiosInstance
    .post(`/coobject/documentpartinclude/linknontagetik/${driveItemId}`, request)
    .then((resp) => resp.data);
}

export function getCoObjectDocumentPartInclude(
  docPartId: string,
  docPartIncludedId: string,
  order: number
): Promise<CoObjectDocumentPartInclude> {
  return axiosInstance
    .get(`${BASE_PATH}/documentpartinclude/${docPartId}/${docPartIncludedId}/${order}`)
    .then((resp) => resp.data);
}

export function getCoObjectsDocumentPartInclude(
  docPartId: string,
  docPartIncludedId: string
): Promise<CoObjectDocumentPartInclude[]> {
  return axiosInstance
    .get(`${BASE_PATH}/documentpartinclude/${docPartId}/${docPartIncludedId}`)
    .then((resp) => resp.data);
}

export function getCoObjectListToUpdate(documentId: string): Promise<CoObjectDocumentPartInclude[]> {
  return axiosInstance.get(`${BASE_PATH}/${documentId}/documentpartinclude`).then((resp) => resp.data);
}

export function getActiveDocumentPartIncludeContentControlIds(documentId: string): Promise<string[]> {
  return axiosInstance.get(`${BASE_PATH}/${documentId}/documentpartinclude/contentcontrols`).then((resp) => resp.data);
}

/*
 ********* LIST COOBJECT **********
 */

export function listDocumentCoObjects(documentId: string): Promise<SourceListItem[]> {
  return axiosInstance.get(`${BASE_PATH}/${documentId}`).then((resp) => resp.data);
}

export function listAllDocumentCoObjects(documentId: string): Promise<SourceListItem[]> {
  return axiosInstance.get(`${BASE_PATH}/recursive/${documentId}`).then((resp) => resp.data);
}

/*
 ******* DELETE COOBJECT **********
 */

export function coObjectTableDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/table/delete/${coObjectId}`).then((response) => response);
}

export function coObjectAmountDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/amount/delete/${coObjectId}`).then((response) => response);
}

export function coObjectAmountAIHDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/amountaih/delete/${coObjectId}`).then((response) => response);
}

export function coObjectDimensionAttributeDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/dimensionattribute/delete/${coObjectId}`).then((response) => response);
}

export function coObjectCheckBoxDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/checkbox/delete/${coObjectId}`).then((response) => response);
}

export function coObjectDropDownDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/dropdown/delete/${coObjectId}`).then((response) => response);
}

export function coObjectFreeTextDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/freetext/delete/${coObjectId}`).then((response) => response);
}

export function coObjectTgkTextDelete(coObjectId: string): Promise<any> {
  return axiosInstance.delete(`${BASE_PATH}/tgktext/delete/${coObjectId}`).then((response) => response);
}

export function getServerVersionedDocumentObjects(documentId: string): Promise<VersionedDocumentObject> {
  return axiosInstance.get(`${BASE_PATH_SYNC}/${documentId}`).then((response) => response.data);
}

export function syncVersionedDocumentObjects(
  syncVersionedDocumentObjectRequest: SyncVersionedDocumentObjectRequest
): Promise<string> {
  return axiosInstance
    .post(`${BASE_PATH_SYNC}/synch`, syncVersionedDocumentObjectRequest)
    .then((response) => response.data);
}

export function abortElaboration(elaborationRequest: ElaborationAbortRequest): Promise<string> {
  return axiosInstance.put(`/elaboration/abort`, elaborationRequest).then((response) => response.data);
}

export function getTrackedChangesForCoObject(objectId: string): Promise<TrackedObjChange[]> {
  return axiosInstance.get(`${BASE_PATH_CHANGES_TRACKER}/${objectId}`).then((response) => response.data);
}

export function lockCoObject(objectId: string, lock: boolean): Promise<CoObject> {
  return axiosInstance.post(`${BASE_PATH}/${objectId}/lock?lock=${lock}`, []).then((resp) => resp.data);
}

export function exportObjects(documentId: string): Promise<ArrayBuffer> {
  return axiosInstance
    .post(`${BASE_PATH}/${documentId}/exportDocumentObjectList`, [], {
      responseType: "arraybuffer",
    })
    .then((resp) => resp.data);
}

export function getActiveObjectForContentControlId(documentId: string, contentControlId: string): Promise<CoObject> {
  return axiosInstance.get(`${BASE_PATH}/${documentId}/${contentControlId}`).then((resp) => resp.data);
}
